import { render, staticRenderFns } from "./TheaterIndex.vue?vue&type=template&id=159f308a&scoped=true&"
import script from "./TheaterIndex.vue?vue&type=script&lang=js&"
export * from "./TheaterIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f308a",
  null
  
)

export default component.exports